module.exports = __webpack_public_path__ + "static/training_unten_cropped-b2bc6ec08037f96769881971f7a03dd5.jpg";